export const theme =
{
    code: 'editor-code',
    heading: {
        h1: 'editor-heading-h1',
        h2: 'editor-heading-h2',
        h3: 'editor-heading-h3',
        h4: 'editor-heading-h4',
        h5: 'editor-heading-h5',
    },
    image: 'editor-image',
    link: 'editor-link',
    list: {
        listitem: 'editor-listitem',
        nested: {
            listitem: 'editor-nested-listitem',
        },
        ol: 'editor-list-ol',
        ul: 'editor-list-ul',
    },
    ltr: 'ltr',
    paragraph: 'editor-paragraph',
    placeholder: 'editor-placeholder',
    quote: 'editor-quote',
    rtl: 'rtl',
    text: {
        bold: 'editor-text-bold',
        code: 'editor-text-code',
        hashtag: 'editor-text-hashtag',
        italic: 'editor-text-italic',
        overflowed: 'editor-text-overflowed',
        strikethrough: 'editor-text-strikethrough',
        underline: 'editor-text-underline',
        underlineStrikethrough: 'editor-text-underlineStrikethrough',
    },
    layoutContainer: 'editor-layout_container',
    layoutItem: 'editor-layout_item',
    // table: 'editor-table',
    table: 'editor-table_table',
    tableAddColumns: 'editor-table_tableAddColumns',
    tableAddRows: 'editor-table_tableAddRows',
    tableAlignment:
    {
        center: 'editor-table_tableAlignmentCenter',
        right: 'editor-table_tableAlignmentRight',
    },
    tableCell: 'editor-table_tableCell',
    tableCellActionButton: 'editor-table_tableCellActionButton',
    tableCellActionButtonContainer: 'editor-table_tableCellActionButtonContainer',
    tableCellHeader: 'editor-table_tableCellHeader',
    tableCellResizer: 'editor-table_tableCellResizer',
    tableCellSelected: 'editor-table_tableCellSelected',
    tableFrozenColumn: 'editor-table_tableFrozenColumn',
    tableFrozenRow: 'editor-table_tableFrozenRow',
    tableRowStriping: 'editor-table_tableRowStriping',
    tableScrollableWrapper: 'editor-table_tableScrollableWrapper',
    tableSelected: 'editor-table_tableSelected',
    tableSelection: 'editor-table_tableSelection',
};